if (!customElements.get('legal-collection-card')) {
  customElements.define('legal-collection-card', class LegalCollectionCard extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.addEventListener('click', this.onClick);
      this.querySelector('product-form')?.addEventListener('submit', () => {
        this.track('legal_collection_add_intent', {
          product_id: this.dataset.productId,
          variant_id: this.querySelector('input[name="id"]')?.value,
        });
      });
    }

    onClick = (event) => {
      const option = event.target.closest('[data-option]');
      if (option && this.contains(option)) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (option.getAttribute('aria-current') === 'true' || this.selectOption(option)) {
          event.preventDefault();
        }
        return;
      }

      const cta = event.target.closest('[data-card-cta]');
      if (cta && this.contains(cta)) {
        cta.classList.remove('is-clicked');
        // Restart the short press animation on repeated clicks without delaying checkout.
        void cta.offsetWidth;
        cta.classList.add('is-clicked');
        window.clearTimeout(cta._legalClickTimer);
        cta._legalClickTimer = window.setTimeout(() => cta.classList.remove('is-clicked'), 400);
      }

      const productLink = event.target.closest('[data-product-link]');
      if (productLink && this.contains(productLink)) {
        this.track('legal_collection_product_open', { product_id: this.dataset.productId });
      }
    };

    selectOption(option) {
      const purchase = this.querySelector('.legal-conversion-card__purchase');
      const form = purchase?.querySelector('product-form');
      const required = {
        price: purchase?.querySelector('[data-price]'),
        pricePrefix: purchase?.querySelector('[data-price-prefix]'),
        compare: purchase?.querySelector('[data-compare]'),
        unit: purchase?.querySelector('[data-unit]'),
        count: purchase?.querySelector('[data-count]'),
        unitPrice: purchase?.querySelector('[data-unit-price]'),
        rating: this.querySelector('[data-rating-link]'),
        ratingText: this.querySelector('[data-rating-text]'),
        delivery: purchase?.querySelector('[data-delivery]'),
        modeLabel: purchase?.querySelector('[data-mode-label]'),
        detailsCTA: purchase?.querySelector('[data-details-cta]'),
        detailsCTALabel: purchase?.querySelector('[data-details-cta-label]'),
        addLabel: form?.querySelector('[data-add-label]'),
        variantInput: form?.querySelector('input[name="id"]'),
        submitButton: form?.querySelector('button[type="submit"]'),
        subscriptionLink: purchase?.querySelector('[data-subscription-link]'),
      };

      // Leave the link navigable if a section is incomplete or data is missing.
      if (!option.dataset.id || !option.dataset.url || !option.dataset.price ||
          !option.dataset.variantId || Object.values(required).some((node) => !node)) return false;

      try {
        const cups = Number(option.dataset.cups) || 0;
        const canAdd = option.dataset.canAdd === 'true';

        this.querySelectorAll('[data-product-link], [data-details-link], [data-details-cta], [data-subscription-link]').forEach((link) => {
          link.href = option.dataset.url;
        });
        const mediaLink = this.querySelector('.legal-conversion-card__media a');
        if (mediaLink) mediaLink.setAttribute('aria-label', `Voir ${option.dataset.title}`);

        const image = this.querySelector('[data-product-image]');
        if (image && option.dataset.image) {
          image.src = option.dataset.image;
          image.srcset = option.dataset.imageSrcset || '';
          image.alt = option.dataset.imageAlt || option.dataset.title;
        }

        // Read display fields inside the purchase panel. Option links also have
        // data-price and data-unit-price attributes.
        required.price.textContent = option.dataset.price;
        required.pricePrefix.hidden = option.dataset.priceVaries !== 'true';
        required.compare.textContent = option.dataset.compare || '';
        required.compare.hidden = !option.dataset.compare;
        required.unit.hidden = cups <= 0;
        const mobileUnitPrice = this.querySelector('[data-mobile-unit-price]');
        if (mobileUnitPrice) {
          mobileUnitPrice.hidden = cups <= 0;
          mobileUnitPrice.textContent = cups > 0 ? option.dataset.unitPrice : '';
        }
        if (cups > 0) {
          required.count.textContent = `${cups} tasses`;
          required.unitPrice.textContent = option.dataset.unitPrice;
        }

        required.rating.hidden = !option.dataset.rating;
        required.rating.href = `${option.dataset.url}#judgeme_product_reviews`;
        required.ratingText.textContent = option.dataset.rating || '';
        const mobileRating = this.querySelector('[data-mobile-rating-link]');
        if (mobileRating) {
          mobileRating.hidden = !option.dataset.rating;
          mobileRating.href = `${option.dataset.url}#judgeme_product_reviews`;
          const mobileRatingText = mobileRating.querySelector('[data-mobile-rating-text]');
          if (mobileRatingText) mobileRatingText.textContent = option.dataset.rating ? `★ ${option.dataset.rating}` : '';
        }
        const mobileMeta = this.querySelector('[data-mobile-meta]');
        if (mobileMeta) mobileMeta.hidden = !mobileMeta.querySelector(':scope > span:not([hidden])') && !mobileMeta.querySelector('[data-mobile-rating-link]:not([hidden])');
        required.delivery.hidden = option.dataset.shipping !== 'true';
        required.modeLabel.hidden = !(canAdd && option.dataset.subscription === 'true');
        form.hidden = !canAdd;
        required.detailsCTA.hidden = canAdd;
        const noun = option.dataset.format ? 'café' : 'produit';
        required.detailsCTALabel.textContent = option.dataset.available === 'true' ? `Choisir ce ${noun}` : `Voir ce ${noun}`;
        required.variantInput.value = option.dataset.variantId;
        form.error = false;
        required.submitButton.removeAttribute('aria-disabled');
        form.querySelector('.sold-out-message')?.classList.add('hidden');
        const error = form.querySelector('.product-form__error-message-wrapper');
        if (error) error.hidden = true;
        required.addLabel.classList.remove('hidden');
        required.addLabel.textContent = cups > 0 ? `Ajouter ${cups} ${option.dataset.format}` : 'Ajouter au panier';
        required.subscriptionLink.hidden = option.dataset.subscription !== 'true';
        required.subscriptionLink.href = `${option.dataset.url}#legal-product-purchase`;

        [...this.classList]
          .filter((className) => className.startsWith('legal-product-palette--') || className.startsWith('legal-home-product--palette-'))
          .forEach((className) => this.classList.remove(className));
        (option.dataset.paletteClasses || '').split(/\s+/).filter(Boolean).forEach((className) => this.classList.add(className));
        this.querySelectorAll('[data-option]').forEach((candidate) => candidate.removeAttribute('aria-current'));
        option.setAttribute('aria-current', 'true');
        this.dataset.productId = option.dataset.id;

        this.track('legal_collection_pack_selected', {
          product_id: option.dataset.id,
          variant_id: option.dataset.variantId,
          cups,
        });
        return true;
      } catch (error) {
        console.error('Unable to select collection pack', error);
        return false;
      }
    }

    track(eventName, details) {
      window.LegalTracking?.track(eventName.replace(/^legal_/, ''), {
        surface: 'collection',
        collection_card_index: this.dataset.listIndex,
        ...details,
      });
    }
  });
}

// Share the text row heights within each visible product-grid row.
(() => {
  const container = document.querySelector('#ProductGridContainer');
  if (!container) return;
  let frame = 0;

  const alignRows = () => {
    frame = 0;
    const alignedTracks = window.matchMedia('(max-width: 749px)').matches ? 3 : 2;
    const cards = [...container.querySelectorAll('#product-grid.legal-conversion-grid .legal-conversion-card')]
      .filter((card) => card.getBoundingClientRect().width > 0);
    const groups = new Map();

    cards.forEach((card) => {
      const body = card.querySelector('.legal-conversion-card__body');
      if (!body) return;
      for (let row = 1; row <= 5; row += 1) body.style.removeProperty(`--legal-card-row-${row}`);
      const top = Math.round(card.getBoundingClientRect().top);
      if (!groups.has(top)) groups.set(top, []);
      groups.get(top).push(body);
    });

    groups.forEach((bodies) => {
      const heights = Array(alignedTracks).fill(0);
      bodies.forEach((body) => {
        const tracks = getComputedStyle(body).gridTemplateRows.split(' ');
        for (let index = 0; index < alignedTracks; index += 1) {
          heights[index] = Math.max(heights[index], parseFloat(tracks[index]) || 0);
        }
      });
      bodies.forEach((body) => heights.forEach((height, index) => {
        if (height) body.style.setProperty(`--legal-card-row-${index + 1}`, `${height}px`);
      }));
    });
  };

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(alignRows);
  };

  new MutationObserver(schedule).observe(container, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['hidden'],
  });
  window.addEventListener('resize', schedule);
  document.fonts?.ready.then(schedule);
  schedule();
})();
